import * as React from 'react';
import { ColumnGeneratorFunc } from 'components/ComposableTable';

type Props = {
  element: React.ReactElement;
};

function HoverCell({ element }: Props) {
  return <div className="ComposableTable-hoverCell">{element}</div>;
}

export function wrapInHoverCell<T>(generator: ColumnGeneratorFunc<T>) {
  return (input: T) => {
    return <HoverCell element={generator(input)} />;
  };
}
